module.exports = __webpack_public_path__ + "static/media/version.47077c01.bin";